import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 判定結果がまだない完了チェックの表示コンポーネント
 *
 * 完了チェッカーが判定中（running）か、判定の途中で中断された（cancelled）ときに、
 * 判定結果（CompletionCheckResultView）の代わりに出す。チェッカーの作業は
 * この下にサブエージェントの作業と同じ形式で並ぶ。desktop-app / web で共通利用する。
 */
import { Loader2, PauseCircle } from 'lucide-react';
import { cn } from '../utils';
export function CompletionCheckPendingView({ state, className }) {
    const isRunning = state === 'running';
    return (_jsx("div", { role: "status", className: cn('overflow-hidden rounded-lg border border-border bg-muted/30', className), children: _jsxs("div", { className: "flex items-center gap-2 px-4 py-2.5 text-sm", children: [isRunning ? (_jsx(Loader2, { className: "h-4 w-4 shrink-0 animate-spin text-muted-foreground" })) : (_jsx(PauseCircle, { className: "h-4 w-4 shrink-0 text-muted-foreground" })), _jsx("span", { className: "font-medium text-foreground", children: isRunning ? '完了チェック: 確認中' : '完了チェック: 中断' })] }) }));
}
//# sourceMappingURL=CompletionCheckPendingView.js.map